import { gql } from '@apollo/client';

export const REAL_TIME_METRIC = gql`
  query RealTime_GetMetric($timePeriod: String!) {
    RealTime_GetMetric(timePeriod: $timePeriod) {
      saleMetric {
        callMetric {
          overall {
            totalCall
            totalPickUpCall
            totalCallDuration
            totalCallPerSalesman
            averagePickUpCallPerSalesman
            averageCallDurationPerSalesman
          }
          topBusinessUnits {
            businessUnitId
            businessUnitName
            totalPickUpCall
            rank
          }
          topBusinessAreas {
            businessAreaId
            businessAreaName
            totalPickUpCall
            rank
          }
          topSaleMans {
            userId
            userName
            totalCall
          }
          lastUpdate
        }
        performanceMetric {
          timePeriod
          overall {
            totalRevenue
            kpiProgress
            achievedPerSalesman
            cr45
          }
          cr45 {
            top3BusinessUnits {
              businessAreaName
              businessAreaId
              cr45
              rank
            }
            top5BusinessUnits {
              businessUnitName
              businessUnitId
              cr45
              rank
            }
          }
          revenue {
            top3BusinessUnits {
              businessAreaName
              businessAreaId
              revenueAchieved
              rank
            }
            top5BusinessUnits {
              businessUnitName
              businessUnitId
              revenueAchieved
              rank
            }
            top10Salemans {
              userId
              userName
              revenueAchieved
              rank
            }
          }
          kpiRevenue {
            top3BusinessUnits {
              businessAreaId
              businessAreaName
              kpiProgress
              kpiAchieved
              rank
            }
            top5BusinessUnits {
              businessUnitName
              businessUnitId
              kpiProgress
              kpiAchieved
              rank
            }
            top10Salemans {
              userId
              userName
              kpiProgress
              kpiAchieved
              rank
            }
          }
          lastUpdate
        }
      }
    }
  }
`;
